import { Box, styled } from "@mui/material";
const OptionContainer = styled(Box, { name: "MainContainer", slot: "optionContainer" })`
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  flex-wrap: nowrap;
  display: flex;
  width: 100%;
`;
export {
  OptionContainer
};
//# sourceMappingURL=OptionContainer.js.map
